import { Icon } from '@joor/design-system'
import { typography } from '@joor/design-system'
import styled from 'styled-components'

enum ContactTestIds {
  contactName = 'contact-name-item',
}

const StyledIcon = styled(Icon)`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 32px;
  width: 32px;

  border-radius: 50%;
  border: 1px solid var(--color-primary-200);
  color: var(--color-primary-200);
`

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
`

const Info = styled.div`
  line-height: 16px;
`

const PrimaryText = styled.span`
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-800);
`

const SecondaryText = styled.span`
  ${typography.alpha.primaryActive.body3}
  color: var(--color-primary-400);
`

type ContactProps = {
  name?: string
  title?: string
  email?: string
  onClickName?: () => void
  className?: string
}

export const Contact = ({
  name,
  title,
  email,
  onClickName,
  className,
}: ContactProps) => (
  <Container className={className}>
    <StyledIcon iconName="person" variant="DISABLED" />
    <Info>
      <PrimaryText
        data-testid={ContactTestIds.contactName}
        onClick={onClickName}
      >
        {name}
      </PrimaryText>{' '}
      {title && <SecondaryText>({title})</SecondaryText>}
      <div>{email && <SecondaryText>{email}</SecondaryText>}</div>
    </Info>
  </Container>
)
